export const EMPLOYEE_WORKSPACE_BUTTON_TITLE = 'Workspaces'
export const EMPLOYEE_WORKSPACE_BUTTON_ALT = 'Workspaces'
export const EMPLOYEE_WORKSPACE_BUTTON_ICON = '/images/icons/employee_workspace_icon.svg'
export const EMPLOYEE_WORKSPACE_BUTTON_WIDTH = 28
export const EMPLOYEE_WORKSPACE_BUTTON_HEIGHT = 28
